<script>
    export let count = 4;
</script>

<div class="section full">
    <div class="wide-block transparent p-0">
        <ul class="nav nav-tabs lined iconed" role="tablist">
            {#each {length: count} as _, i}
                <li class="nav-item placeholder-glow">
                    <a class="nav-link {i === 0 ? 'active' : ''}" data-bs-toggle="tab" href="#{i}" role="tab" aria-selected="false">
                        <span class="placeholder col-7"></span>
                    </a>
                </li>
            {/each}
        </ul>
    </div>
</div>
